export const headerMatches = {
    id: "ID",
    eventId: "Event ID",
    name: "Event Name",
    datetimeString: "Time",
    venue: "Venue",
    teamName: "Team Name",
    datetime: "Date",
    count: "Count",
    canTransfer: "Can Transfer?",
    tokenState: "State",
    // Ticket-list mock data
    teamID: "Team ID",
    account: "Account",
    requested: "Requested",
    result: "Result",
    // eventName: "Event Name",
    eventVenue: "Event Venue",
    eventDate: "Event Date",
    section: "Section",
    row: "Row",
    seat: "Seat",
    // Paciolan specific
    event_id: "Event ID",
    team: "Team",
    event: "Event",
    year: "Year",
    barcode: "Barcode",
    event_season_name: "Season Name",
    event_date: "Event Date (ISO)",
    ticket_id_eres: "Ticket ID ERES",
    ticket_id_transfer: "Ticket ID Transfer",
    ticket_id_seat: "Ticket ID Seat",
    ticket_level: "Ticket Level",
    ticket_is_transferable: "Is Transferable",
    ticket_transfer_status: "Transfer Status",
    ticket_transfer_id: "Transfer ID",
    ticket_is_sellable: "Is Sellable",
    ticket_is_nfc_enabled: "NFC Enabled",
    ticket_id_mta: "Ticket ID MTA",
    account_team: "Account Team",
    account_user: "Account User",
    // Others
    _item: "Item",
}

export const headerWidthMatches = {
    id: "50px",
    team: "100px",
    teamId: "150px",
    event_id: "100px",
    section: "100px",
    row: "100px",
    seat: "100px",
    name: "250px",
    event: "200px",
    eventName: "200px",
    action: "225px",
    time_range: "150px",
    status: "120px",
    editor: '200px',
    requested: '140px',
    request_type: "220px",
    request_time: "120px",
    time: "120px",
    created_at: '182px',
    result: "180px",
    additional: "150px",
    // Paciolan specific widths
    account: "200px",
    account_team: "120px",
    account_user: "200px",
    date: "120px",
    year: "80px",
    venue: "200px",
    barcode: "150px",
    event_season_name: "150px",
    event_date: "180px",
    ticket_id_eres: "150px",
    ticket_id_transfer: "180px",
    ticket_id_seat: "180px",
    ticket_level: "120px",
    ticket_is_transferable: "130px",
    ticket_transfer_status: "140px",
    ticket_transfer_id: "150px",
    ticket_is_sellable: "120px",
    ticket_is_nfc_enabled: "120px",
    ticket_id_mta: "150px",
}

export const headerIgnoreValues = [
    'canTransfer',
    'tokenState',
    'password',
    'id',
    'timestamp',
]

export const headerAlignmentValues = {
    count: 'center',
    section: 'center',
    row: 'center',
    seat: 'center',
    data: 'center',
    status: 'center',
    created_at: 'center',
    time: 'center',
    _item: ' d-none',
    _search: ' d-none',
}

export const headerGroupByValues = [
    'event',
    'section',
    'row',
    'seat',
    'date',
    'venue',
    'editor',
    'status',
    'request_type',
    'account_user',
    'event_id',
    'additional',
    'team',
]